import React, { useEffect } from "react";
import { Tabs, TabList, TabPanels, Tab, TabPanel, Highlight, Box, Text, Flex, Heading, ListItem, Link as MyLink, ListIcon, List, Divider } from '@chakra-ui/react'
import "./common.css";
import Image from "../assets/img/About/Image.gif";
import VanillaTilt from 'vanilla-tilt';
import { Link } from "react-scroll";
import AOS from 'aos'
import 'aos/dist/aos.css'
import { HiCheckCircle } from "react-icons/hi"
import { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";
const bs = {
  border: "1px solid #35B4E2",
  borderRadius: "7%",
  margin: "auto"
}

const options = {
  scale: 1.1,
  speed: 1000,
  max: 30
};

const About = () => {
  const { Theme } = useContext(ThemeContext)
  useEffect(() => {
    AOS.init();
  }, [])
  return (
    <section className={`${Theme === "dark" && "darkBackground1"} section  pt-10`} id="about" >
      <Tilt options={options} Theme={Theme} />
      <Tabs variant='soft-rounded' align="center"  >
        <TabList>
          <Tab _selected={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` }} bg={Theme === "dark" ? "#61605e" : "#fff"} color={Theme === "dark" ? "#fff" : "#000"} ml={["3", "3", "5", "6", "7"]} className='boxShadow' _hover={{ bg: '#F08E8B', color: 'white' }} >About</Tab>
          <Tab _selected={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` }} bg={Theme === "dark" ? "#61605e" : "#fff"} color={Theme === "dark" ? "#fff" : "#000"} ml={["3", "3", "5", "6", "7"]} className='boxShadow' _hover={{ bg: '#F08E8B', color: 'white' }}>Experience</Tab>
        </TabList>
        <div className="container mx-auto mt-20" data-aos="fade-up" data-aos-duration="1000">
          <div className="flex flex-col xl:flex-row gap-24">
            <img style={bs} className={`lg:hidden border-4 h-full w-[370px] ${Theme === "dark" ? "border-[#F2AA4CFF]" : ' border-red-400'}`} src={'https://i.ibb.co/CvgCGgC/Picsart-23-01-06-19-52-24-727.png'} alt={'Monu'} />
            <img
              className={` hidden lg:block object-cover h-full w-[450px] border-4 md:mx-auto lg:mx-auto rounded-2xl coderImage ${Theme === "dark" ? "border-[#F2AA4CFF]" : ' border-red-400'}`}
              src={Image}
              alt="Monu"
            />

            <TabPanels>
              {/* About Panel */}
              <TabPanel>
                <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
                  <div className="flex flex-col">
                    <Text mb={"3"} color={Theme === "dark" ? "#8f8b89" : "black"} className={`papa`}><span>Full-Stack</span> Web <span>Developer</span></Text>
                    <hr className="mb-8 opacity-5" />
                    <Text mb={"10"} fontSize={["15", "15", "16", "18", "18"]} fontWeight={"400"} color={Theme === "dark" ? "#8f8b89" : "#383736"}>
                      Hello! My name is Monu Yadav & I enjoy creating things that live on the internet. I'm a passionate Developer, with strong administrative & communication skills, good attention to detail & the ability to write efficient code.<br />
                      <Divider my="3" borderColor={"gray.400"} />
                      I'm open to Job opportunities. If you think my skills are relevant to your job requirements then do contact me.
                    </Text>
                  </div>
                  <Link
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    duration={500}
                    offset={-70}
                    className="transition-all duration-300"
                    to={"contact"}
                  >
                    <button className={`relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium transition-all ${Theme === "dark" ? "bg-[#F2AA4CFF]" : "bg-red-500"} rounded-xl group`}>
                      <span className={`absolute top-0 right-0 inline-block w-4 h-4 transition-all duration-500 ease-in-out ${Theme === "dark" ? "bg-[#ba8f32]" : "bg-red-900"} rounded group-hover:-mr-4 group-hover:-mt-4`}>
                        <span className="absolute top-0 right-0 w-5 h-5 rotate-45 translate-x-1/2 -translate-y-1/2 bg-white"></span>
                      </span>
                      <span className={`absolute bottom-0 left-0 w-full h-full transition-all duration-500 ease-in-out delay-200 -translate-x-full translate-y-full ${Theme === "dark" ? "bg-[#ba8f32]" : "bg-red-400"} rounded-2xl group-hover:mb-12 group-hover:translate-x-0`}></span>
                      <span className={`relative w-full text-left ${Theme === "dark" ? "text-black-400" : "text-white"} transition-colors duration-200 ease-in-out group-hover:${Theme === "dark" ? "text-black-400" : "text-white"}`}>Contact me</span>
                    </button>
                  </Link>
                </div>
              </TabPanel>
              {/* Experience Panel */}
              <TabPanel>
                <Flex borderBottom={Theme === 'dark' && "8px solid #fff"} flexDir={"column"} className="boxShadow" w={["100%", "100%", "600px", "600px", "500px"]} bg={Theme === "dark" ? "#7a7976" : "#fff"} py="7" borderRadius={"10"} textAlign={[null, null, null, "left", null]}  >
                  {/* Heading */}
                  <Flex flexDir={["column", "column", "row", "row", "row"]} w="90%" margin={"auto"} justifyContent={"space-between"} >
                    <Flex flexDir={"column"}  >
                      <Heading fontSize={"19"} color={Theme === "dark" ? "#F2AA4CFF" : "#555755"} textAlign={"left"} >Success Webtech</Heading>
                      <Text color={Theme === "dark" ? "blackAlpha.700" : "#555755"} as='i' textAlign={"left"} fontWeight={"450"} >Full Stack Developer</Text>
                    </Flex>
                    <Flex flexDir={"column"} mt={["5", "5", 0, 0, 0]}   >
                      <Text color={Theme === "dark" ? "blackAlpha.700" : "#555755"} textAlign={["left", "left", null, null, null]} fontSize={"15"} fontWeight={"500"} >Noida, Uttar Pradesh</Text>
                      <Text color={Theme === "dark" ? "blackAlpha.700" : "#555755"} textAlign={["left", "left", null, null, null]} fontSize={"15"} fontWeight={"500"} as='i'>Feb 2022 - Feb 2023 </Text>
                    </Flex>
                  </Flex>
                  {/* Desciption of experience */}
                  <List spacing={3} w="90%" m="auto" mt="5" >
                    <ListItem color={Theme === "dark" ? "blackAlpha.700" : "#717572"} textAlign={"left"} fontSize={"14"} fontWeight={"500"}>
                      <ListIcon as={HiCheckCircle} color={Theme === "dark" ? "#F2AA4CFF" : "red.400"} />
                      Developed and maintained web applications using languages such as HTML, CSS, JavaScript and ReactJS
                    </ListItem>
                    <ListItem color={Theme === "dark" ? "blackAlpha.700" : "#717572"} textAlign={"left"} fontSize={"14"} fontWeight={"500"} >
                      <ListIcon as={HiCheckCircle} color={Theme === "dark" ? "#F2AA4CFF" : "red.400"} />
                      This opportunity has allowed me to apply my knowledge and learn from experienced professionals in the industry
                    </ListItem>
                    <ListItem color={Theme === "dark" ? "blackAlpha.700" : "#717572"} textAlign={"left"} fontSize={"14"} fontWeight={"500"}>
                      <ListIcon as={HiCheckCircle} color={Theme === "dark" ? "#F2AA4CFF" : "red.400"} />
                      Implemented responsive designs
                    </ListItem>
                    <ListItem color={Theme === "dark" ? "blackAlpha.700" : "#717572"} textAlign={"left"} fontSize={"14"} fontWeight={"500"}>
                      <ListIcon as={HiCheckCircle} color={Theme === "dark" ? "#F2AA4CFF" : "red.400"} />
                      Developed successwebtech website <MyLink isExternal={true} color={Theme === "dark" ? "#F2AA4CFF" : "red.400"} href='https://www.successwebtech.com/'>
                        www.successwebtech.com
                      </MyLink>
                    </ListItem>
                  </List>
                </Flex>
              </TabPanel>
            </TabPanels>


          </div>
        </div>
      </Tabs>
    </section>
  );
};


function Tilt(props) {
  const { options, Theme } = props;
  const tilt = React.useRef(null);

  useEffect(() => {
    VanillaTilt.init(tilt.current, options);
  }, [options]);

  return <Box w={"50%"} ref={tilt} m="auto" >
    <Text color={Theme === "dark" ? "#fff" : "#000"} fontWeight='bold' mb="5" mt="15" fontSize={["20", "20", "30", "40", "40"]} textAlign={"center"} >
      <Highlight
        query={['About', 'Experience']}
        styles={{ color: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` }}
      >
        All About Me  & My Experience
      </Highlight>
    </Text>
  </Box>
}
export default About;
